export default __webpack_public_path__ + "static/media/git.8ee81345.svg";